import React from "react";
import { useLocation } from "react-router-dom";
import QPhototModuleSubtopic from "../../QPhotoModuleSubtopic";

const ALL_OS_SUBTOPICS = [
    { name: 'Introduction to OS: Functionality of OS - OS design issues', path: '/os-m1-s1' },
    { name: 'Structuring methods (monolithic, layered, modular, micro-kernel models)', path: '/os-m1-s2' },
    { name: 'Abstractions, processes, resources - Influence of security, networking, and multimedia', path: '/os-m1-s3' },
    { name: 'System calls, System/Application Call Interface', path: '/os-m2-s1' },
    { name: 'Protection: User/Kernel modes - Interrupts', path: '/os-m2-s2' },
    { name: 'Processes - Structures (Process Control Block, Ready List etc.), Process creation, management in Unix', path: '/os-m2-s3' },
    { name: 'Threads: User level, kernel level threads and thread models', path: '/os-m2-s4' },
    { name: 'Processes Scheduling - CPU Scheduling: Pre-emptive, non-pre-emptive - Multiprocessor scheduling', path: '/os-m3-s1' },
    { name: 'Deadlocks - Resource allocation and management - Deadlock handling mechanisms: prevention, avoidance, detection, recovery.', path: '/os-m3-s2' },
    { name: 'Inter-process communication, Synchronization - Implementing synchronization primitives (Peterson\'s solution, Bakery algorithm, synchronization hardware)', path: '/os-m4-s1' },
    { name: 'Semaphores – Classical synchronization problems', path: '/os-m4-s2' },
    { name: 'Monitors: Solution to Dining Philosophers problem', path: '/os-m4-s3' },
    { name: 'Main memory management, Memory allocation strategies', path: '/os-m5-s1' },
    { name: 'Virtual memory: Hardware support for virtual memory (caching, TLB) – Paging – Segmentation', path: '/os-m5-s2' },
    { name: 'Demand Paging - Page Faults - Page Replacement - Thrashing - Working Set', path: '/os-m5-s3' },
    { name: 'Virtual Machines - Virtualization (Hardware/Software, Server, Service, Network - Hypervisors - Container virtualization - Cost of virtualization)', path: '/os-m6-s1' },
    { name: 'File system implementation (directory implementation, file allocation methods) - File system recovery - Journaling - Soft updates - Log-structured file system - Distributed file system.', path: '/os-m6-s2' },
    { name: 'Disk structure and attachment – Disk scheduling algorithms (seek time, rotational latency based)', path: '/os-m7-s1' },
    { name: 'System threats and security – Policy vs mechanism - Access vs authentication - System protection: Access matrix – Capability based systems', path: '/os-m7-s2' }
];

const OSModuleSubtopic = ({ title, videos, pdfLink, takeaways, questions, exampleVideos }) => {
    const location = useLocation();
    const { subtopics = ALL_OS_SUBTOPICS, subjectPath = '/subject-OSModules' } = location.state || {};

    return (
        <QPhototModuleSubtopic
            title={title}
            videos={videos}
            pdfLink={pdfLink}
            takeaways={takeaways}
            questions={questions}
            exampleVideos={exampleVideos}
            subtopics={subtopics || ALL_OS_SUBTOPICS}
            subjectPath={subjectPath}
        />
    );
};

export default OSModuleSubtopic;
